import { Paging } from '@zdrbm/zdr-interfaces';
import { IImage } from '../../../infra';

export interface SuggestionDTO {
    agent_id: string;
    query: string;
}

export interface GetSuggestionsRequest {
    query: string;
    maxResults?: number;
    session?: string;
}

export interface GetSuggestionsResponse {
    suggestions: SuggestionDTO[];
    session?: string;
}

export interface ContainerDTO {
    id: string;
    type: string;
    data: unknown;
}
export type ResourceDataType = 'image_url';
export interface ResourceDTO {
    type: ResourceDataType;
    data: unknown;
}

export const RunStatus = {
    PENDING: 'PENDING',
    RUNNING: 'RUNNING',
    COMPLETED: 'COMPLETED',
    REJECTED: 'REJECTED',
    FAILED: 'FAILED',
};

export type RunStatusType = typeof RunStatus[keyof typeof RunStatus];

export interface RunDTO {
    id: string | undefined;
    conversation_id: string;
    input: string;
    image?: IImage;
    resources: ResourceDTO[] | null;
    started_at: string;
    created_at: string;
    updated_at: string;
    status: RunStatusType;
    containers: ContainerDTO[];
}

export interface ConversationDTO {
    id: string;
    title: string | undefined;
    timestamp: string | undefined;
}

interface HistoryConversationMetadata {
    user_id: string;
    title: string | undefined;
}

export interface HistoryConversationDTO {
    id: string;
    timestamp: string;
    metadata: HistoryConversationMetadata;
}

export interface ListConversationsRequest {
    paging?: Paging;
}

export interface ListConversationsResponse {
    conversations: HistoryConversationDTO[];
}

export interface CreateConversationResponse {
    conversation_id: string;
}

export interface ScreenshotInfoDTO {
    screenshot_support: boolean;
    screenshot_base64?: string | null;
    screenshot_permission_denied: boolean;
}

export interface CreateRunRequest {
    conversationId: string;
    content: string;
    screenshotInfo?: ScreenshotInfoDTO;
}
export interface CreateRunResponse {
    run: RunDTO;
}

export interface ListConversationRunsRequest {
    conversationId: string;
}

export interface ListConversationRunsResponse {
    runs: RunDTO[];
}

export interface GetRunRequest {
    conversationId: string;
    runId: string;
}

export interface GetRunResponse {
    run: RunDTO;
}
export interface GetConversationRequest {
    conversationId: string;
}
export interface DeleteConversationRequest {
    conversationId: string;
}
export interface DeleteConversationResponse {}
export interface GetConversationResponse {
    conversation: ConversationDTO | undefined;
}

export interface SendConversationFeedbackRequest {
    conversationId: string;
    score: number;
    feedback: string;
}
export interface SendRunFeedbackRequest {
    conversationId: string;
    runId: string;
    score: number;
    feedback: string;
}

export interface GenerateConversationTitleRequest {
    conversationId: string;
}
export interface GenerateConversationTitleResponse {
    conversation: HistoryConversationDTO;
}
